import type { PracticalProject } from "../../data";

export const aiChat: PracticalProject = {
  id: "ai-chat",
  num: 3,
  title:
    "実践プロジェクト③ AIチャットアプリ — TypeScript + Express + React + OpenAI APIでLLM統合をフルスタック構築する",
  description:
    "NORTH CRAFT サポートボット相当の AI チャットを、モック → 本番 LLM 差し替え設計込みで構築",
  duration: "1〜2か月",
  techStack: ["TypeScript", "Express", "React", "Vite", "OpenAI API"],
  figmaUrl:
    "https://www.figma.com/design/5LLAPdI03tsb3z0ufTofP6/?node-id=13-1892",
  demoUrl: "https://prod-luagate-pj-aichat-frontend-v3bbmayaea-an.a.run.app",
  starterUrl: "https://prod-luagate-pj-aichat-starter-frontend-645657172748.asia-northeast1.run.app",
  repoUrl: "https://github.com/Luagate-com/luagate_pj_ai_chat_app",
  starterRepoUrl:
    "https://github.com/Luagate-com/luagate_pj_ai_chat_app/tree/starter",
  difficulty: "advanced",
  phase: "Phase 5",
  learningOutcomes: [
    "LLM API(OpenAI) を組み込んだフルスタックアプリを開発できる",
    "プロンプトエンジニアリング・履歴管理・コスト制御の現場感覚を身につける",
    "モック → 本番 LLM 差し替えを前提とした設計ができるようになる",
    "AI チャットアプリをポートフォリオに持てる",
  ],
  chapters: [
    { num: 1, title: "はじめに" },
    { num: 2, title: "ヒアリング" },
    { num: 3, title: "企画書" },
    { num: 4, title: "要件定義" },
    {
      num: 5,
      title: "基本設計",
      figmaFrames: [{ title: "AI チャット画面 (メイン)", nodeId: "13-1892" }],
    },
    { num: 6, title: "詳細設計" },
    { num: 7, title: "実装の進め方" },
    { num: 8, title: "7-1: 環境構築とリポジトリの起動" },
    { num: 9, title: "7-2: API スケルトンとモック応答" },
    { num: 10, title: "7-3: 履歴管理とインメモリストア" },
    {
      num: 11,
      title: "7-4: Frontend チャット UI と API 連携",
      figmaFrames: [{ title: "AI チャット画面 (メイン)", nodeId: "13-1892" }],
    },
    {
      num: 12,
      title: "7-5: OpenAI API への差し替えとプロンプト設計",
    },
    { num: 13, title: "7-6: エラーハンドリングと安全装置" },
    {
      num: 14,
      title: "7-7: モバイル UI とアクセシビリティ調整",
      figmaFrames: [{ title: "AI チャット画面 (メイン)", nodeId: "13-1892" }],
    },
    { num: 15, title: "7-8: 仕上げ (セキュリティ・配色・ヘッダ)" },
    { num: 16, title: "実装 FAQ (詰まったとき用)" },
    { num: 17, title: "テスト・提出" },
    { num: 18, title: "用語ミニ辞書" },
  ],
};
